module.exports = __webpack_public_path__ + "img/bottle.a8eeb478.svg";